module.exports = __webpack_public_path__ + "static/media/ipv_demo.b90ee3db.jpg";